import { getAges } from 'api/ages.api';
import { getEthnicities } from 'api/ethnicities.api';
import { getGenders } from 'api/genders.api';
import { getOtherConditions } from 'api/otherConditions.api';
import { getRoles } from 'api/roles.api';
import { handleRefreshDbUser } from 'components/global/_helpers/global.helpers';
import { $form, $user, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';

export const fetchAndSetFounderProfileData = async () => {
  try {
    $view.update({
      isLoading: true,
    });
    await handleRefreshDbUser({ isSoft: true });
    $form.reset();

    const [{ data: ages }, { data: genders }, { data: ethnicities }, { data: otherConditions }, { data: roles }] = await Promise.all([
      getAges(),
      getGenders(),
      getEthnicities(),
      getOtherConditions(),
      getRoles({ userType: $user.value.userType }),
    ]);

    const ageOptions = ages?.map(ageItem => ({ value: ageItem.id, label: ageItem.description }))
      .sort((a, b) => a.label.localeCompare(b.label)) || [];
    const genderOptions = genders?.map(genderItem => ({ value: genderItem.id, label: genderItem.description }))
      .sort((a, b) => a.label.localeCompare(b.label)) || [];
    const ethnicityOptions = ethnicities?.map(ethnicityItem => ({ value: ethnicityItem.id, label: ethnicityItem.description }))
      .sort((a, b) => a.label.localeCompare(b.label)) || [];
    const otherConditionOptions = otherConditions?.map(condition => ({ value: condition.id, label: condition.description }))
      .sort((a, b) => a.label.localeCompare(b.label)) || [];
    const roleOptions = roles?.map(role => ({ value: role.id, label: role.description }))
      .sort((a, b) => a.label.localeCompare(b.label)) || [];

    // Find matching option objects for select fields
    const ageOption = ageOptions.find(option => option.value === $user.value.ageId);
    const genderOption = genderOptions.find(option => option.value === $user.value.genderId);
    const ethnicityOption = ethnicityOptions.find(option => option.value === $user.value.ethnicityId);

    $form.update({
      firstName: $user.value.firstName,
      lastName: $user.value.lastName,
      age: ageOption || null,
      gender: genderOption || null,
      ethnicity: ethnicityOption || null,
      otherConditions: $user.value.otherConditions,
      roles: $user.value.roles,
      profileImage: $user.value.profileImage,
      avatarColors: $user.value.avatarColors,
    });

    $view.update({
      ageOptions,
      genderOptions,
      ethnicityOptions,
      otherConditionOptions,
      roleOptions,
    });
  } catch (error) {
    console.error(error);
    displayError({
      message: 'Failed to load profile data. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    $view.update({
      isLoading: false,
    });
  }
};
